import { Controller } from "@hotwired/stimulus"
import { filterBarParams } from "../lib/analytics_filters"

// Carries the filter bar's current selections into a form submit (CSV export, chart edit mode).
export default class extends Controller {
  injectFilters() {
    filterBarParams().forEach((value, name) => this.addHiddenField(name, value))
  }

  addHiddenField(name, value) {
    const input = document.createElement("input")
    input.type = "hidden"
    input.name = name
    input.value = value
    this.element.appendChild(input)
  }
}
